import { ChatTeardropSlashIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const RemovedComment = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChatTeardropSlashIcon size={Sizes[size]} {...rest} color={fill} />;
};

RemovedComment.displayName = 'RemovedComment';
